module.exports = __webpack_public_path__ + "img/财务结算.4bf1b8fe.svg";